<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useProfileStore } from '@/presentation/stores/profile/profile.ts'
import CNavHeader from './CNavHeader.vue'
import CNavMenu from './CNavMenu.vue'
import PButton from 'primevue/button'

// Store
const profileStore = useProfileStore()
const { isMenuOpened } = storeToRefs(profileStore)

// Local state
const version = __APP_VERSION__

// Methods
function toggleSidebar() {
  profileStore.toggleMenuOpen()
}
</script>

<template>
  <div
    class=" cursor-default item border-r-surface-300 flex h-screen max-w-72 flex-col justify-between border-r transition-[width,opacity] duration-300 ease-in-out"
    :class="[isMenuOpened ? 'w-72 opacity-100' : 'w-24 opacity-100']"
  >
    <!-- En-tête : logo et profil -->
    <CNavHeader :is-fully-opened="isMenuOpened" />

    <!-- Menu de navigation (avec scrolling) -->
    <div class="grow overflow-y-auto">
      <CNavMenu :is-fully-opened="isMenuOpened" />
    </div>

    <div
      class="flex h-fit w-full items-center gap-2"
      :class="isMenuOpened ? 'justify-between' : 'justify-end'"
    >
      <p v-if="isMenuOpened" class="align-center block w-full px-2 text-left text-xs text-gray-400">
        © {{ new Date().getFullYear() }} - v{{ version }}
      </p>
      <!-- Bouton de bascule du menu -->
      <p-button
        @click="toggleSidebar()"
        icon="pi pi-arrow-left"
        text
        rounded
        aria-label="toggle menu"
        class="_m-Lateral-Menu-Toggle origin-center border-0 transition-transform duration-200 ease-in-out"
        :class="isMenuOpened ? 'rotate-0' : 'rotate-180'"
      />
    </div>
  </div>
</template>